module.exports = __webpack_public_path__ + "img/gun-hestia.e7131e3f.jpg";